import { render, staticRenderFns } from "./NormalFemale.vue?vue&type=template&id=d2fabd20&scoped=true&"
import script from "./NormalFemale.vue?vue&type=script&lang=js&"
export * from "./NormalFemale.vue?vue&type=script&lang=js&"
import style0 from "./NormalFemale.vue?vue&type=style&index=0&id=d2fabd20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fabd20",
  null
  
)

export default component.exports